module.exports = __webpack_public_path__ + "static/media/about_left.7a8610e7.png";